import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs';

import { addManagementTypesToAdmin, getDefaultWidgetConfigAdminForm } from '@feature/widget-admin/services/widget-admin-form';
import { WidgetConfiguration, WidgetConfigurationsService } from '@feature/widget-configs';
import { WidgetAdminHandler } from '@widget-admin/services/widget-admin-handler';
import { FormDefinition  } from '@feature/_app_modules/dynamic-forms/dynamic-form';
import { mapWherePropertiesMatch } from '@common/index';
import * as contactUsActions from '@contact-us/actions/contactus';
import * as contactUsSelectors from '@contact-us/selectors/contactus';
import { select, Store } from '@ngrx/store';
import { ApplicationState } from '@store/application-store';
import { IManagementType } from '@common/models/management-type';

@Injectable({
  providedIn: 'root'
})
export class ContactUsWidgetAdminHandler implements WidgetAdminHandler {

  private managementTypes: IManagementType[];

  constructor(
    private readonly widgetConfigService: WidgetConfigurationsService,
    private readonly store: Store<ApplicationState>
  ) { }

  initialise(): Observable<boolean> {

    this.store.dispatch(new contactUsActions.LoadAdminData());
    const getManagementTypes =  this.store.pipe(select(contactUsSelectors.getManagementTypes),
      tap(types => this.managementTypes = types),
      map(t => true)
    );

    return getManagementTypes;

  }

  getAdminForm(selectedConfig: WidgetConfiguration): FormDefinition {

    let formDefinition = getDefaultWidgetConfigAdminForm(selectedConfig);

    formDefinition = addManagementTypesToAdmin(selectedConfig, this.managementTypes, formDefinition);

    return formDefinition;

  }

  createCopyFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    const copyOfSelectedConfig: WidgetConfiguration = mapWherePropertiesMatch(selectedConfig, adminFormValue);

    this.mapSelectedManagerCodesToConfig(copyOfSelectedConfig, adminFormValue);

    return this.widgetConfigService.createcopy(copyOfSelectedConfig).pipe(
      map(r => true)
    );

  }

  private mapSelectedManagerCodesToConfig(config: WidgetConfiguration, adminFormValue: any) {
    if (adminFormValue.selectedManagerCodes) {
        config.selectedManagerCodes = adminFormValue.selectedManagerCodes.map(x => {
        return x.Code;
      });
    }
  }

  saveConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {

    const copyOfSelectedConfig: WidgetConfiguration = mapWherePropertiesMatch(selectedConfig, adminFormValue);

    this.mapSelectedManagerCodesToConfig(copyOfSelectedConfig, adminFormValue);

    return this.widgetConfigService.save(copyOfSelectedConfig).pipe(
      map(r => true)
    );

  }

  deleteConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    const copyOfSelectedConfig: WidgetConfiguration = mapWherePropertiesMatch(selectedConfig, adminFormValue);

    this.mapSelectedManagerCodesToConfig(copyOfSelectedConfig, adminFormValue);

    return this.widgetConfigService.delete(copyOfSelectedConfig).pipe(
      map(r => true)
    );

  }

}



